import React from "react";
import SectionImg from "../../common/images/section_one_andoroid.png";
const Section_one = () => {
  return (
    <div>
      <div
        className="relative bg-secondary  bg-cover bg-center bg-no-repeat text-white md:py-7 py-5 "
        style={{ backgroundImage: "url('/android-dot.png')" }}
      >
        {/* Main Heading */}
        <div className="max-w-[1280px] mx-auto text-center px-5 md:px-10 md:py-7 py-5">
            <h2 className="small:text-3xl text-2xl font-bold md:text-4xl ">
              Our Android App
            </h2>{" "}
            <h2 className="small:text-3xl text-2xl font-bold md:text-4xl">
              {" "}
              Development Services
            </h2>
          <div className="underline w-1/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-primary">
            <p className="h-[5px] rounded-xl bg-primary w-[50%]"></p>
          </div>

          <p className="mt-4 max-w-5xl mx-auto">
            At Binary Ops, we offer a full range of Android app development
            services designed to meet your business goals. From initial strategy
            to final deployment, we ensure every step is handled with precision
            and expertise.
          </p>
        </div>

        {/* Image Below Paragraph */}
        <div className="mt-6 flex justify-center">
          <img
            src={SectionImg}
            alt="Illustration"
            className="w-full px-5 md:max-w-5xl"
          />
        </div>
      </div>
    </div>
  );
};

export default Section_one;
